<template>
  <div class="projects">
    <div v-if="isLoading">
      <p>Loading...</p>
    </div>

    <div v-for="(project, id) in projects" :key="id" class="project">
      <div class="project__name">{{ project.name }}</div>
      <div class="project__preview">
        <a class="link-edit" @click="goToProject(id)">
          <img :src="project.preview" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import api from "../../api";
import fake from "../../fake";

export default {
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    ...mapState(["selectedProject", "selectedScene", "projects"]),
    ...mapGetters(["getProjects"])
  },
  mounted() {
    this.setSelectedProject(null);
    this.setSelectedScene(null);
    if (!this.projects.length) {
      this.loadProjects();
    } else {
      this.isLoading = false;
    }
  },

  methods: {
    ...mapMutations(["setProjects", "setSelectedProject", "setSelectedScene"]),
    loadProjects: function() {
      api.projects.loadProjects().then(response => {
        // handle success
        this.setProjects(response.data);
        this.isLoading = false;
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      // .then(projects => {
      //   this.setProjects({ projects });
      //   this.isLoading = false;
      // });
    },
    goToProject: function(id) {
      this.$router.replace({ path: `project/${id}` });
    },
    deleteProject: function(id) {
      const isDelete = confirm("Are you sure you want to delete this project?");

      if (isDelete) {
        api.projects.deleteProject(id).then(response => {
        // handle success
        this.loadProjects();
        }).catch(function (error) {
          // handle error
          console.log(error);
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.projects {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.project {
  position: relative;
  width: calc(50% - 40px);
  background-size: cover;
  background-position: center;
  margin: 15px;

  .editor.sidebarIsActive & {
    width: 100%;
  }

  &__actions {
    display: flex;
    justify-content: space-between;

    .button {
      margin-left: 5px;
    }
  }

  .project__action--left {
    .button {
      margin-left: 0;
    }
  }

  &__name {
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    font-weight: 300;
    font-size: 22px;
    color: #333;
    padding: 0;
  }

  &__preview {
    margin-bottom: 10px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    a {
      cursor: pointer;
    }
  }
}
</style>
